module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_8004.9be22ef0.png";